// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".click-for-more{margin:5px 10px}", "",{"version":3,"sources":["webpack://./widget/tint/shared/components/click-for-more/click-for-more.sass"],"names":[],"mappings":"AAAA,gBACE,eAAA","sourcesContent":[".click-for-more\n  margin: 5px 10px"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
